export function plural(count: number, one: string, many = `${one}S`): string {
  return count === 1 ? one : many;
}
